import { render, staticRenderFns } from "./ConsultationAndCase.vue?vue&type=template&id=08260487"
import script from "./ConsultationAndCase.vue?vue&type=script&lang=ts"
export * from "./ConsultationAndCase.vue?vue&type=script&lang=ts"
import style0 from "./ConsultationAndCase.vue?vue&type=style&index=0&id=08260487&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports